import { appStore } from "@app/store/store"
import { ADRESS_TYPES } from "./constants"

export const createAmazonButtonConfig = locale => {
	return {
		merchantId: appStore.get("settings.amazonMerchantId"),
		publicKeyId: appStore.get("settings.amazonPublicKeyId"),
		ledgerCurrency: "EUR",
		checkoutLanguage: locale.replace("-", "_"),
		productType: "PayAndShip",
		placement: "Cart",
		buttonColor: "Gold",
	}
}

export function mapAmazonToAddresses(amazonPayData) {
	const invoiceAddress = {
		firstName: amazonPayData.billingAddress.name,
		lastName: "",
		address: amazonPayData.billingAddress.addressLine1 || amazonPayData.billingAddress.addressLine2 || amazonPayData.billingAddress.addressLine2,
		zipCode: amazonPayData.billingAddress.postalCode,
		city: amazonPayData.billingAddress.city,
		houseNo: "",
		countryCode: amazonPayData.billingAddress.countryCode,
		addressTypeId: ADRESS_TYPES.INVOICE,
		isAmazon: true,
	}

	const deliveryAddress = amazonPayData.shippingAddress
		? {
				firstName: amazonPayData.shippingAddress.name,
				lastName: "",
				address: amazonPayData.shippingAddress.addressLine1 || amazonPayData.shippingAddress.addressLine2 || amazonPayData.shippingAddress.addressLine2,
				zipCode: amazonPayData.shippingAddress.postalCode,
				city: amazonPayData.shippingAddress.city,
				houseNo: "",
				countryCode: amazonPayData.shippingAddress.countryCode,
				addressTypeId: ADRESS_TYPES.DELIVERY,
				isAmazon: true,
			}
		: { ...invoiceAddress }

	return {
		deliveryAddress,
		invoiceAddress,
	}
}
